import React, { useState, useEffect } from 'react'
import { getCookie } from 'cookies-next'
import { useRouter } from 'next/router'
import Select from 'react-select'
import { Languages } from '../../../data/languages'
import styles from '../../../styles/Home.module.css'
import { validateEmail, phoneNumber } from '../../../utils/validation'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { Countries, StatesUSA, CountryPhoneCode } from '../../../data/Countries'
import { post } from '@/utils/directory'
import Icon from '@/components/Icon'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'


// const Post = require('../../../utils/HTTPRequests')
const ToastContainer = require('react-toastify').ToastContainer
const toast = require('react-toastify').toast
var parse = require('html-react-parser')

const DemoForm = (props) => {
  let [pDemo, setPdemo] = useState({
    fn: '',
    ea: '',
    pn: '+1',
    cn: '',
    ne: '',
    cnt: '',
    st: 'ca',
  })

  const router = useRouter()

  const [message, setMessage] = useState('')
  const [tagManager, setTagManager] = useState('')
  const [capterra, setCapterra] = useState(0)

  useEffect(() => {
    const countries = () => {
      let countries = Object.entries(Countries).filter(([key, value]) => value === 'United States')
      setPdemo({
        ...pDemo,
        cnt: countries[0][0],
        st: 'ca',
      })
    }
    countries()
  }, [Countries])

  // useEffect(() => {
  //   post('Stats', 'Access', JSON.stringify({ Query: router.query, Path: router.asPath })).then((res) => {})
  // }, [])

  const onChangepDemo = (e) => {
    if (e.target.name === 'cnt') {
      let countries = Object.entries(Countries).filter(([key, value]) => value === e.target.value)
      setPdemo({
        ...pDemo,
        cnt: countries[0][0],
      })
    }else if(e.target.name=== "pn"){  
      var pattern = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]+$/;
     if(pattern.test(e.target.value)){
       e.preventDefault()
       setPdemo({
         ...pDemo,
         [e.target.name]: e.target.value,
       })
     }
    } else {
      e.preventDefault()

      setPdemo({
        ...pDemo,
        [e.target.name]: e.target.value,
      })
    }
  }

  const selectLocation = (option) => {
    let phoneNo = Object.entries(CountryPhoneCode).filter(([key, value]) => key === option.value)
    setPdemo({
      ...pDemo,
      cnt: option.value,
      // pn: phoneNo[0][1],
      st: '',
      pn:CountryPhoneCode[option.value]
    })
  }

  const selectState = (option) => {
    setPdemo({
      ...pDemo,
      st: option.value,
    })
  }

  const selectLanguage = (option) => {
    //setLanguage(option.value)
    props?.selectLanguage(option.value)
  }

  //List Country
  let countryDropdown
  let countryData = Object.entries(Countries).map(([key, value]) => {
    return { value: key, label: value }
  })
  //Select Default Value
  let defaultValue = '',
    countryCode,
    sCountryList
  countryCode = Object.entries(Countries).filter(([key, value]) => key === 'us')
  sCountryList = countryCode.map((res) => res)
  let value = `${sCountryList[0][1]}`
  defaultValue = { value: value, label: value }

  if (countryData) {
    countryDropdown = <Select instanceId={defaultValue} options={countryData} defaultValue={defaultValue} placeholder="Select Country" onChange={selectLocation} />
  }

  //List State
  let stateDropdown
  let stateData = Object.entries(StatesUSA).map(([key, value]) => {
    return {
      value: key,
      label: value.charAt(0).toUpperCase() + value.slice(1),
    }
  })
  //Select Default Value
  let defaultValueState = '',
    stateCode,
    sStateList
  stateCode = Object.entries(StatesUSA).filter(([key, value]) => key === 'ca')
  sStateList = stateCode.map((res) => res)
  let valueState = `${sStateList[0][1]}`
  defaultValueState = {
    value: valueState,
    label: valueState.charAt(0).toUpperCase() + valueState.slice(1),
  }

  if (stateData) {
    stateDropdown = <Select options={stateData} placeholder="Select State" defaultValue={defaultValueState} onChange={selectState} />
  }

  //Language Dropdown
  let languageDropdown
  let languageData = Object.entries(Languages).map(([key, value]) => {
    return { value: key, label: value }
  })
  //Select Default Value
  let defaultLang = '',
    languageCode,
    sLanguageList
  languageCode = Object.entries(Languages).filter(([key, value]) => key === 'en')
  sLanguageList = languageCode.map((res) => res)
  let valueLang = `${sLanguageList[0][1]}`
  defaultLang = { value: valueLang, label: valueLang }

  if (languageData) {
    languageDropdown = <Select instanceId={defaultLang} options={languageData} defaultValue={defaultLang} placeholder="Select Language" onChange={selectLanguage} />
  }

  let campaign = getCookie('WebHR_Campaign_Info')
  let getReferrer = getCookie('WebHR_Campaign_Referrer_Path');
  const referrer = getReferrer?JSON.parse(getReferrer):null
  const SubmitPersonalizedDemo = (e) => {
    e.preventDefault()
    const additionalInfo = {
      RouterInfo: { asPath: router.asPath, query: router.query },
      ReferenceInfo: campaign && JSON.parse(campaign),
      RefererPath: referrer?.refererPath
    }
    if (pDemo.fn !== '' && pDemo.ea !== '' && validateEmail(pDemo.ea) && pDemo.pn !== '' && phoneNumber(pDemo.pn) && pDemo.cn !== '' && pDemo.ne !== '' && pDemo.cnt !== '') {
      let data = {
        rt2: 'ScheduleDemo',
        ContactPerson: pDemo.fn,
        EmailAddress: pDemo.ea,
        PhoneNumber: pDemo.pn,
        OrganizationName: pDemo.cn,
        NumberOfEmployees: pDemo.ne,
        Country: pDemo.cnt,
        State: pDemo.st,
      }
      post('Website', 'Requests', JSON.stringify({ ...data, AdditionalInfo: additionalInfo})).then((res) => {
        if (res.data.Status == 1) {
          toast(res.data.Message)
          if (res.data.Data.TagManagerId != '') setTagManager(res.data.Data.TagManagerId)
          if (res.data.Data.Capterra === 1) setCapterra(res.data.Data.Capterra)
          setMessage('success')
        } else if (res.data.Status == -2) {
          toast(res.data.Message)
          setMessage(res.data.Message)
        } else {
          toast('Something Went Wrong')
          setMessage('Something Went Wrong')
        }
      })
    } else {
      if (pDemo.fn === '') {
        toast('Please enter your full name')
      } else if (pDemo.ea === '') {
        toast('Please enter your email address')
      } else if (!validateEmail(pDemo.ea)) {
        toast('Invalid Email Address')
      } else if (pDemo.pn === '') {
        toast('Please enter your phone number')
      } else if (!phoneNumber(pDemo.pn)) {
        toast('Please enter valid phone number')
      } else if (pDemo.cn === '') {
        toast('Please enter your company name')
      } else if (pDemo.ne === '') {
        toast('Please enter number of employees')
      }
      //  else if (pDemo.st === '') {
      //   toast('Please enter your state')
      // }
       else {
        toast('Something wents wrong')
        setMessage('Missing or Invalid Data')
      }
    }
  }

  return (
    <>
      <Row className="whr_form-banner">
        <Col
          md={7}
          style={{
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center',
          }}
          className="whr_form-banner-col1"
        >
          {parse(props?.Html)}
        </Col>

        <Col
          className={`whr_form-banner-col1 ${styles.formContainer}`}
          style={{
            height: '100%',
            borderRadius: '1em',
            minHeight: '632px',
          }}
        >
          {message === 'success' ? (
            <div className='formSubmitSuccess' style={{ textAlign: 'center' }}>
              <Icon Icon={faCircleCheck} size={"80px"} color={'#54CC7C'} style={{ marginRight: 10 }} />
              <h5
                style={{
                  margin: '1.5em 0',
                  fontSize: '20px',
                  lineHeight: '30px',
                }}
              ></h5>
              <h5
                style={{
                  margin: '1.5em 0 0.25em 0',
                  fontSize: '20px',
                  lineHeight: '30px',
                }}
              >
                One of our representatives will reach out to you soon to schedule your Personalized Demo!
              </h5>
              {tagManager && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: `<script  src="https://www.googletagmanager.com/gtag/js?id=${props.tagManager}"></script><script >
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${props.tagManager}', {
              page_path: window.location.pathname,
            });
          </script>`,
                  }}
                ></div>
              )}
              {capterra == 1 && (
                
                <div
                  dangerouslySetInnerHTML={{
                    __html: `<script>var capterra_vkey = \'842150c71b896789e077ed0b2b7d53a1\',
                        capterra_vid = \'2081075\',
                        capterra_prefix = ((\'https:\' == document.location.protocol) ? \'https://ct.capterra.com\' : \'http://ct.capterra.com\');
                          (function() {
                            var ct = document.createElement(\'script\'); ct.type = \'text/javascript\'; ct.async = true;
                        ct.src = capterra_prefix + \'/capterra_tracker.js?vid=\' + capterra_vid + \'&vkey=\' + capterra_vkey;
                            var s = document.getElementsByTagName(\'script\')[0]; s.parentNode.insertBefore(ct, s);
                          })();</script>`,
                  }}
                ></div>
              )}
              {capterra == 1 && <img src={`https://ct.capterra.com/capterra_tracker.gif?vid=${props.capterraVal1}&vkey=${props.capterraVal2}`} />}
            </div>
          ) : (
            <div>
              <h3 className={styles.smHeading}>Schedule a Personalized Demo to experience WebHR!</h3>
              <br />
              <div>
                <Form onSubmit={SubmitPersonalizedDemo}>
                  <Row>
                    <Col sm={12} md={6} lg={6} xl={6} className={styles.demoFields}>
                      <Form.Group>
                        <Form.Label>Your Full Name</Form.Label>
                        <Form.Control type="text" placeholder="Jone Doe" name="fn" value={pDemo.fn} onChange={onChangepDemo} />
                      </Form.Group>
                    </Col>
                    <Col sm={12} md={6} lg={6} xl={6} className={styles.demoFields}>
                      <Form.Group>
                        <Form.Label>Your Business Email</Form.Label>
                        <Form.Control type="text" placeholder="j.doe@bluecube.com" name="ea" value={pDemo.ea} onChange={onChangepDemo} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group className={styles.demoFields}>
                        <Form.Label>Your Company Name</Form.Label>
                        <Form.Control type="text" placeholder="BlueCube" name="cn" value={pDemo.cn} onChange={onChangepDemo} />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className={styles.demoFields}>
                        <Form.Label>Number of Employees</Form.Label>
                        <Form.Control type="number" min={0} placeholder="50" name="ne" value={pDemo.ne} onChange={onChangepDemo} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} md={6} lg={6} xl={6} className={styles.demoFields}>
                      <Form.Label>Country</Form.Label>
                      {countryDropdown}
                    </Col>
                    <Col>
                      <Form.Group className={styles.demoFields}>
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control type="tel" placeholder="+1" name="pn" value={pDemo.pn} onChange={onChangepDemo} />
                      </Form.Group>
                    </Col>
                  </Row>
                   
                    {/* </Col> */}
                  {/* <Form.Group className={styles.demoFields}>
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control type="tel" placeholder="Phone Number" name="pn" value={pDemo.pn} onChange={onChangepDemo} />
                  </Form.Group> */}
                  <Button className={styles.primaryBtnBanner2} type="submit">
                    Schedule a Demo
                  </Button>
                </Form>
              </div>
            </div>
          )}
        </Col>
      </Row>
      <ToastContainer position="bottom-left" autoClose={2500} hideProgressBar newestOnTop={false} closeOnClick={false} rtl={false} pauseOnFocusLoss draggable={false} pauseOnHover={false} />
    </>
  )
}

export default DemoForm
